export default __webpack_public_path__ + "static/media/senti-ipad.5be703a1.png";